import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Icon,
  CircularProgress,
} from "@mui/material";
import { SuperAdminStats } from "../../types/super-admin.types";

interface StatCardProps {
  title: string;
  value: number;
  icon: string;
  color: string;
  isLoading: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color,
  isLoading,
}) => (
  <Paper
    sx={{
      p: 3,
      borderRadius: 2,
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          bgcolor: `${color}15`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ color: color }}>{icon}</Icon>
      </Box>
    </Box>
    {isLoading ? (
      <CircularProgress size={24} />
    ) : (
      <Typography variant="h4" component="div">
        {typeof value === "number"
          ? value.toLocaleString("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })
          : "0"}
      </Typography>
    )}
  </Paper>
);

interface DashboardStatsProps {
  stats: Partial<SuperAdminStats>;
  isLoading: boolean;
}

export const DashboardStats: React.FC<DashboardStatsProps> = ({
  stats,
  isLoading,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total Clients"
          value={stats?.totalClients ?? 0}
          icon="groups"
          color="#2196f3"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Active Clients"
          value={stats?.activeClients ?? 0}
          icon="check_circle"
          color="#4caf50"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total Revenue"
          value={stats?.totalRevenue ?? 0}
          icon="attach_money"
          color="#ff9800"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="New Clients"
          value={stats?.newClientsThisMonth ?? 0}
          icon="person_add"
          color="#f44336"
          isLoading={isLoading}
        />
      </Grid>
    </Grid>
  );
};
